import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export const Input: React.FC<InputProps> = ({ label, error, style, ...props }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
    {label && <label style={{ fontSize: '13px', fontWeight: 500, color: 'var(--text)' }}>{label}</label>}
    <input
      style={{
        padding: '9px 12px',
        border: `1px solid ${error ? 'var(--error)' : 'var(--border)'}`,
        borderRadius: 'var(--radius)',
        fontSize: '14px',
        outline: 'none',
        width: '100%',
        color: 'var(--text)',
        background: 'white',
        ...style,
      }}
      {...props}
    />
    {error && <span style={{ fontSize: '12px', color: 'var(--error)' }}>{error}</span>}
  </div>
);
